export default "__VITE_ASSET__eaa8ec7f__"